/* eslint-disable react-hooks/exhaustive-deps */
import { DataTable } from '@/components/Ui';
import { ProposalType, useSchoolProposalList } from './schoolProposalList.hook';
import { Button } from '@/components/Common';

const SchoolProposalList = () => {
  const {
    schoolsProposalsList,
    columns,
    openSchoolProposalModal,
    setSchoolProposal,
    setMode,
    schoolProposalListPage,
    setSchoolProposalListPage,
    schoolProposalListlimit,
    setSchoolProposalListLimit,
  } = useSchoolProposalList();

  const handleActionClick = (
    proposalDetail: ProposalType,
    mode: 'validate' | 'refuse',
  ) => {
    setSchoolProposal({ ...proposalDetail });
    openSchoolProposalModal();
    setMode(mode);
  };

  const proposalList = schoolsProposalsList?.map((item) => {
    const proposalDetail = {
      id: item.id,
      school: item.school || 'N/A',
      region: item.region || 'N/A',
      privateOrPublic: item.privateOrPublic || 'N/A',
    };
    return {
      ...proposalDetail,
      action: (
        <div role="img" className="flex gap-2" aria-label="Icone utilisateur">
          <Button
            title="Valider"
            onClick={() => handleActionClick(proposalDetail, 'validate')}
          />
          <Button
            icon={<i className="pi pi-times text-[24px] font-bold"></i>}
            className="!bg-completed hover:!outline-completed hover:!text-completed
                hover:!bg-hoverColor"
            onClick={() => handleActionClick(proposalDetail, 'refuse')}
          />
        </div>
      ),
    };
  });

  return (
    <div>
      <DataTable
        columns={columns}
        value={proposalList || []}
        withPaginator={true}
        currentPage={schoolProposalListPage}
        currentPageHandler={setSchoolProposalListPage}
        countTotal={proposalList?.length}
        listlimit={schoolProposalListlimit}
        limitHandler={setSchoolProposalListLimit}
      />
    </div>
  );
};

export default SchoolProposalList;
